import {
  ACTION_BY_STATE,
  PaymentActionVariantEnum,
  TPaymentActionVariant
} from '../data/paymentActions';
import { TPaymentListItem } from '../types/ManagePayments';

/**
 * Maps a payment to the action controls it should show - a pure function of `state`, so the rule
 * can be unit tested without React. The delete button is never hidden by this (even inside the
 * daily delete-block window - see isWithinDeleteBlockWindow) - that's only checked at the moment
 * Delete is actually clicked, see openDeleteDialog in useScheduledPaymentAction.
 */
export const resolvePaymentActionVariant = (
  payment: TPaymentListItem | null
): TPaymentActionVariant => {
  if (!payment) return PaymentActionVariantEnum.NONE;

  return ACTION_BY_STATE[payment.state] ?? PaymentActionVariantEnum.NONE;
};
